<template>
  <div :class="['text-only-block', windowWidth > 767 ? props.alignment : '']">
    <h1 class="text-only-block__title">{{ title }}</h1>
    <div class="text-only-block__content" v-html="content"></div>
    <a
      v-if="props.file"
      :href="props.file"
      target="_blank"
      class="text-only-block__file"
    >
      {{ fileName }}
    </a>
  </div>
</template>

<script lang="ts" setup>
  import { ref, onMounted, onUnmounted } from "vue";

  interface Props {
    title: string;
    content: string;
    file?: string | null;
    fileName?: string | null;
    alignment?: "left" | "right" | "center";
  }

  const props = defineProps<Props>();
  const windowWidth = ref(0);

  const updateWindowWidth = () => {
    windowWidth.value = window.innerWidth;
  };

  onMounted(() => {
    updateWindowWidth();
    window.addEventListener("resize", updateWindowWidth);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", updateWindowWidth);
  });
</script>

<style lang="scss">
  .text-only-block {
    display: flex;
    flex-direction: column;

    &.left {
      width: 50%;
      margin-right: auto;

      .text-only-block__content {
        li {
          list-style-position: inside;
        }
      }
    }

    &.right {
      width: 50%;
      margin-left: auto;

      .text-only-block__content {
        li {
          list-style-position: inside;
        }
      }
    }

    &.center {
      width: 50%;
      margin-inline: auto;

      .text-only-block__content {
        li {
          list-style-position: inside;
        }
      }
    }

    &__title {
      font-size: 2rem;
      margin-bottom: 1rem;
      font-weight: 300;

      @media (min-width: 768px) {
        font-size: 3rem;
        line-height: 56px;
      }
    }

    &__content {
      font-size: 14px;
      line-height: 1.5;

      @media (min-width: 768px) {
        font-size: 1rem;
      }
    }

    &__file {
      font-size: 16px;
      text-decoration: underline;
      text-decoration-thickness: 0.055em;
      text-underline-offset: 0.3em;
    }
  }
</style>
